<!-- 历史库存记录 -->
<template>
   <div class='page_content'>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign" :buttonFlag="false"></v-button>
         <div class="page_content_top_line">
            <vSearch @searchData="searchData" @openSearchs="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
            </vSearch>
         </div>
      </div>
      <el-tabs>
         <el-tab-pane label="历史库存列表">
            <div class="page_content_center">
               <u-table :key="$store.state.tableNum" size="mini" id="tableData" :data="dataShow" :height="tableHeight" border style="width: 100%" show-summary :summary-method="getSummaries" stripe ref="stockTable"
                        :row-style="rowStyle" :header-cell-style="{ background: '#fff' }" :row-height="35" row-key="index" use-virtual>
                  <u-table-column show-overflow-tooltip prop="bgmCode" label="商品编码" width="150px" :sortable="true"></u-table-column>
                  <u-table-column show-overflow-tooltip prop="bgmName" label="通用名称" width="200"></u-table-column>
                  <u-table-column show-overflow-tooltip prop="bgiGename" label="商品名称" width="150"></u-table-column>
                  <u-table-column show-overflow-tooltip prop="coName" label="部门编码" width="150"></u-table-column>
                  <u-table-column show-overflow-tooltip prop="opmName" label="采购员" width="150"></u-table-column>
                  <u-table-column show-overflow-tooltip prop="bgiRegistno" label="注册证号或备案凭证编号" width="200"></u-table-column>
                  <u-table-column show-overflow-tooltip prop="manufacturer" label="生产商" width="200"></u-table-column>
                  <u-table-column show-overflow-tooltip prop="placeorigin" label="产地" width="60"></u-table-column>
                  <u-table-column show-overflow-tooltip prop="spec" label="规格" width="150"></u-table-column>
                  <u-table-column show-overflow-tooltip prop="bgpUnitmeasurement" label="包装单位"></u-table-column>
                  <u-table-column show-overflow-tooltip prop="bgiType" label="商品分类"></u-table-column>
                  <u-table-column show-overflow-tooltip prop="prorangeName" label="剂型"></u-table-column>
                  <u-table-column show-overflow-tooltip prop="manrangeName" label="类别"></u-table-column>
                  <u-table-column show-overflow-tooltip prop="fileNumber" label="档案编号"></u-table-column>
                  <u-table-column show-overflow-tooltip prop="bgiAppnumber" label="批准文号"></u-table-column>
                  <u-table-column show-overflow-tooltip prop="goodAttributes1" label="业务属性1"></u-table-column>
                  <u-table-column show-overflow-tooltip prop="batchno" label="批号" width="120"></u-table-column>
                  <u-table-column show-overflow-tooltip prop="prodate" label="生产日期" width="110">
                     <template slot-scope="scope">
                        <div>
                           {{ $common.getLocalTime(scope.row.prodate) }}
                        </div>
                     </template>
                  </u-table-column>
                  <u-table-column show-overflow-tooltip prop="expidate" label="失效日期" width="110">
                     <template slot-scope="scope">
                        <div>
                           {{ $common.getLocalTime(scope.row.expidate) }}
                        </div>
                     </template>
                  </u-table-column>
                  <u-table-column show-overflow-tooltip prop="bgiPerholder" label="上市许可人" min-width="100">
                  </u-table-column>
                  <u-table-column show-overflow-tooltip prop="smName" label="购进单位" min-width="100">
                  </u-table-column>
                  <u-table-column show-overflow-tooltip prop="days" label="在库天数" min-width="100">
                  </u-table-column>
                  <u-table-column show-overflow-tooltip prop="createTime" label="入库时间" min-width="110">
                     <template slot-scope="{row}">
                        {{ $common.getLocalTime(row.createTime) }}
                     </template>
                  </u-table-column>
                  <u-table-column show-overflow-tooltip prop="psprice" label="采购单价" min-width="100">
                  </u-table-column>
                  <u-table-column show-overflow-tooltip prop="pieceQuantity" label="件装量" min-width="100">
                  </u-table-column>
                  <u-table-column show-overflow-tooltip label="期初" align="center">
                     <u-table-column show-overflow-tooltip prop="inItCount" label="数量" :sortable="true" min-width="100"></u-table-column>
                     <u-table-column show-overflow-tooltip prop="inItMoney" label="金额" :sortable="true" min-width="100"></u-table-column>
                     <u-table-column show-overflow-tooltip prop="inItPsMoney" label="含税金额" :sortable="true" min-width="100"></u-table-column>
                     <u-table-column show-overflow-tooltip prop="inItPackNum" label="件数" :sortable="true" min-width="100"></u-table-column>
                  </u-table-column>
                  <u-table-column show-overflow-tooltip label="入库" align="center">
                     <u-table-column show-overflow-tooltip prop="inCount" label="数量" :sortable="true" min-width="100"></u-table-column>
                     <u-table-column show-overflow-tooltip prop="inMoney" label="金额" :sortable="true" min-width="100"></u-table-column>
                     <u-table-column show-overflow-tooltip prop="inPsMoney" label="含税金额" :sortable="true" min-width="100"></u-table-column>
                     <u-table-column show-overflow-tooltip prop="inPackNum" label="件数" :sortable="true" min-width="100"></u-table-column>
                  </u-table-column>
                  <u-table-column show-overflow-tooltip label="出库" align="center">
                     <u-table-column show-overflow-tooltip prop="outCount" label="数量" :sortable="true" min-width="100"></u-table-column>
                     <u-table-column show-overflow-tooltip prop="outMoney" label="金额" :sortable="true" min-width="100"></u-table-column>
                     <u-table-column show-overflow-tooltip prop="outPsMoney" label="含税金额" :sortable="true" min-width="100"></u-table-column>
                     <u-table-column show-overflow-tooltip prop="outPackNum" label="件数" :sortable="true" min-width="100"></u-table-column>
                  </u-table-column>
                  <u-table-column show-overflow-tooltip label="期末" align="center">
                     <u-table-column show-overflow-tooltip prop="endCount" label="数量" :sortable="true" min-width="100"></u-table-column>
                     <u-table-column show-overflow-tooltip prop="endMoney" label="金额" :sortable="true" min-width="100"></u-table-column>
                     <u-table-column show-overflow-tooltip prop="endPsMoney" label="含税金额" :sortable="true" min-width="100"></u-table-column>
                     <u-table-column show-overflow-tooltip prop="endPackNum" label="件数" :sortable="true" min-width="100"></u-table-column>
                  </u-table-column>
               </u-table>
            </div>
         </el-tab-pane>
      </el-tabs>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <div class="page_content_bottom">
         <el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber" :current-page.sync="currentPage" :page-size.sync="pageSize" :page-sizes="[10, 30, 100, 200, 300,500,1000,1500,2000]"
                        layout="total, sizes, prev, pager, next, jumper" :total="total">
         </el-pagination>
      </div>
      <recordSummary ref="recordSummary"></recordSummary>

   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import FileSaver from "file-saver";
import ArrObj from "./index.js"//数据组
import {
   exportRecordAdd
} from "@/service/printApi.js";
import XLSX from "xlsx";
export default {
   name: "dataQueryTemplate",
   //import引入的组件需要注入到对象中才能使用
   data() {
      //这里存放数据
      return {
         tableHeight: 0,
         getRequestData: {
            bgmName: '', //	通用名称
            batchno: '', //	批号
            bgmId: '',
            start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
            end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
            smName: '',
            smId: '',
            coName: '',
            coId: '',
            prorangeName: "",
            bgiType: "",
         },
         activeName: "0",
         returnData: {
            pages: 0, // 总页数
            total: 0, // 总条数
            pageNum: 0, // 当前页数
            list: [],
         },
         selectedDataIndex: 0,
         reportConditionVos: [],
         reportModuleVos: [],
         tabIndex: 0,
         totalPageData: [],
         dataShow: [],
         // 共几页
         pageNum: 1,
         // 每页显示数量
         pageSize: 10,
         // 当前显示页码
         currentPage: 1,
         // 总共多少条数据
         total: 1,
         // 当前要显示的数据
         pageSizes: [10, 50, 100, 300, 500],
         seId: '',
         seIndex: '',
         sField: '',
         parentSearchData: {},
         seTitle: "",//检索
         DialogVisible: false,
         seWidth: '0',
         numberField: [],//数字类型的数据
         stringField: [],//非数字类型的数据
         pageShowData: [],
         buttonList: [
            {
               jurName: "导出",
               actionType: 1,
            },
            {
               jurName: "记录汇总",
               actionType: 2,
            },
         ]
      };
   },
   watch: {
      "getRequestData.bgmName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               this.getRequestData.bgmId = "";
            }
         },
         deep: true,
      },
      "getRequestData.smName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               this.getRequestData.smId = "";
            }
         },
         deep: true,
      },
      "getRequestData.coName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               this.getRequestData.coId = "";
            }
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      // 动作集合
      actionSet(actionData) {
         switch (actionData.actionType) {
            case 1:
               this.export2Excel()
               break;
            case 2:
               this.recordSummary()
               break;
               break;
         }
      },
      // 获取数据列表
      async getPageInfo() {
         var pathId = parent.getMenuInfo(this.$route.path)
         let responseData = await this.$http.getJur({ ids: [pathId.jurId] })
         if (responseData.status == 200) {
            this.pageShowData = responseData.result
            var obj = {}
            if (this.pageShowData.jurHead) {
               obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
            } else {
               obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
            }
            for (const key in obj) {
               this.$set(this.getRequestData, key, obj[key])
            }
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      //记录汇总
      recordSummary() {
         this.numberField = [];//数字类型的数据
         this.stringField = [];//非数字类型的数据
         ArrObj.stockHistoryList.forEach((key) => {
            if (key.isShow == 0) return
            if (key.fieldType == 'number') {
               this.numberField.push(key)
               return
            }
            this.stringField.push(key)
         })
         let sendData = {
            numberField: this.numberField,
            stringField: this.stringField,
            list: this.returnData.list,
            rpcName: '门店历史库存'
         }
         this.$refs.recordSummary.openBox(sendData)
      },
      // 选中行底色逻辑
      rowStyle({
         row,
         rowIndex
      }) {
         let rowBackground = {}
         if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
         return rowBackground
      },
      getSeWidth(e) {
         // console.log(e);
         this.seWidth = e + "%";
      },
      getWidth(e) {
         // console.log(e);
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         // console.log(e);
         this.seTitle = e;
      },
      //检索带回数据
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val)
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.getRequestData[item] = val[item]
         })
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         this.DialogVisible = true
         this.seId = sId
         this.sField = sField
         this.parentSearchData[type] = this.getRequestData[type]
      },
      //获取当天最后时间戳
      changeTime(val) {
         if (val) {
            var time = val + 24 * 60 * 60 * 1000 - 1
            this.getRequestData.end = time
         }
      },
      toDetail(orderId) {
         this.$parent.toDetail(orderId);
         //    this.$parent.$parent.$parent.toDetail(orderId)
      },
      //   查询
      searchData() {
         this.getRequestData.page = 1;
         this.currentPage = 1
         this.getDataList()
      },
      //表格数据写入excel
      export2Excel() {
         var listData = this.returnData.list
         this.rpmName = '门店历史库存'; //获取当前导出表格标题
         var nameList = ["商品编码", "通用名称", "商品名称", "部门编码", "采购员", "注册证号或备案凭证编号", "生产商", "产地", "规格", "包装单位", "商品分类", "剂型", "类别", "档案编号", "批准文号", "业务属性1", "批号", "生产日期", "失效日期", "上市许可人", "购进单位", "在库天数", "入库时间", "采购单价", "件装量",
            '期初数量', '期初金额', '期初含税金额', '期初件数',
            '入库数量', '入库金额', '入库含税金额', '入库件数',
            '出库数量', '出库金额', '出库含税金额', '出库件数',
            '期末数量', '期末金额', '期末含税金额', '期末件数']; //表格头 显示的所有字段
         var fieldList = ["bgmCode", "bgmName", "bgiGename", "coName", "opmName", "bgiRegistno", "manufacturer", "placeorigin", "spec", "bgpUnitmeasurement", "bgiType", "prorangeName", "manrangeName", "fileNumber", "bgiAppnumber", "goodAttributes1", "batchno", "prodate", "expidate", "bgiPerholder", "smName", "days", "createTime", "psprice", "pieceQuantity",
            'inItCount', 'inItMoney', 'inItPsMoney', 'inItPackNum',
            'inCount', 'inMoney', 'inPsMoney', 'inPackNum',
            'outCount', 'outMoney', 'outPsMoney', 'outPackNum',
            'endCount', 'endMoney', 'endPsMoney', 'endPackNum']; //所有字段 显示的所有字段
         var timeList = []; //date类型的字段 导出之前进行格式转换
         listData.forEach(item => {
            for (const key in item) {
               if (key == 'createTime' || key == 'prodate' || key == 'expidate') {
                  item[key] = this.$common.getLocalTime(item[key])
               }
            }
         })
         // 导出业务逻辑 引用封装好的js方法
         require.ensure([], () => {
            const {
               export_json_to_excel
            } = require("@/assets/excel/Export2Excel");
            //这里使用绝对路径( @表示src文件夹 )，使用@/+存放export2Excel的路径
            const tHeader = nameList; // 导出的excel表头名信息
            const filterVal = fieldList; // 导出的excel表头字段名，需要导出表格字段名
            const list = listData; // 查询的数据list
            // 进行数据json map 格式转换
            const data = this.formatJson(filterVal, list);
            // 调用方法传参      表头名信息 数据  导出的表格名称
            export_json_to_excel(tHeader, data, this.rpmName);
         });
         // 导出次数接口
         var token = sessionStorage.getItem("token");
         let params = {
            exportCount: listData.length,
            featuresName: this.rpmName
         }
         exportRecordAdd(params, token).then((res) => {
            if (res.status === 200) { }
         });
      },
      //格式转换方法
      formatJson(filterVal, jsonData) {
         return jsonData.map((v) => filterVal.map((j) => v[j]));
      },
      determine(columns) {
         if (columns.property == "psprice" || columns.property == "inItCount" || columns.property == "inItMoney"
            || columns.property == "inItPsMoney" || columns.property == "inCount" || columns.property == "inMoney"
            || columns.property == "inPsMoney" || columns.property == "outCount" || columns.property == "outMoney"
            || columns.property == "outPsMoney" || columns.property == "endCount" || columns.property == "endMoney"
            || columns.property == "endPsMoney" || columns.property == "pieceQuantity" || columns.property == "endPackNum"
            || columns.property == "outPackNum" || columns.property == "inPackNum" || columns.property == "inItPackNum"
         ) {
            return true
         }
         return false
      },
      //表格求和
      getSummaries(param) {
         const {
            columns,
            data
         } = param;
         const sums = [];
         columns.forEach((column, index) => {
            if (index === 0) {
               sums[index] = '合计';
               return;
            } else if (index >= 10) {
               const values = data.map(item => Number(item[column.property]));
               if (this.determine(column)) {
                  if (!values.every(value => isNaN(value))) {
                     sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                           return this.toDecimal(prev + curr);
                        } else {
                           return this.toDecimal(prev)
                        }
                     }, 0);
                     //   sums[index] = sums[index].toFixed(2)
                     sums[index] = this.$common.getDecimalInfo(3, sums[index])
                     // sums[index] += ' 元';
                  } else {
                     sums[index] = 'N/A';
                  }
               }
            }
         });
         return [sums];
      },
      toDecimal(x) {
         var f = parseFloat(x);
         if (isNaN(f)) {
            return;
         }
         f = Math.round(x * 100) / 100;
         return f;
      },

      // 获取数据列表
      async getDataList() {
         let responseData = await this.$http.stockStatisticsQueryStoreStockHistory(
            this.getRequestData
         );
         if (responseData.status == 200) {
            this.returnData.list = responseData.result
            this.total = this.returnData.list.length
            this.$store.state.tableNum = this.$store.state.tableNum ? false : true
            this.calcPageData()
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.dataShow = this.totalPageData[val - 1];
      },
      // 切换显示条数
      setDataPageSize(val) {
         this.pageSize = val;
         // 重新计算页数并分组
         this.calcPageData();
      },
      // 前端分页逻辑
      calcPageData() {
         // 计算页数(根据后台数据的条数和每页显示数量算出一共几页,得0时设为1)
         if (this.returnData.list.length > 1) {
            this.pageNum = Math.ceil(this.returnData.list.length / this.pageSize) || 1;
         }
         // 数据分组
         for (let i = 0; i < this.pageNum; i++) {
            // 每一页都是一个数组 形如 [['第一页的数据'],['第二页的数据'],['第三页数据']]
            // 根据每页显示数量 将后台的数据分割到 每一页,假设pageSize为5， 则第一页是1-5条，即slice(0,5)，第二页是6-10条，即slice(5,10)...
            this.totalPageData[i] = this.returnData.list.slice(
               this.pageSize * i,
               this.pageSize * (i + 1)
            );
         }
         // 获取到数据后显示第一页内容,数组下标是从0开始的，这里一定要减去1，不然会丢失一组数据
         this.dataShow = this.totalPageData[this.currentPage - 1];
      },

   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      //   var objs = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
      //   for (const key in objs) {
      //      this.$set(this.getRequestData, key, objs[key])
      //   }
      this.getPageInfo()
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {
      this.$nextTick(() => {
         this.tableHeight = this.$common.getTableHeight() - 40
      })
   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight() - 20 }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.page_content_center {
   overflow-y: auto;
}

.dis {
   display: flex;
   flex-wrap: wrap !important;
}
</style>
